import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/tasks" });

export const TaskService = {
  createTask: (taskData) => api.post("/", taskData),

  getTaskList: (filters) => {
    const params = buildQueryParams(filters);
    return api.get(`/?${params.toString()}`);
  },

  getTaskById: (taskId) => api.get(`/${taskId}`),

  updateTask: (taskId, taskData) => api.patch(`/${taskId}`, taskData),

  deleteTask: (taskId) => api.delete(`/${taskId}`),

  createTaskProgress: (taskId, taskProgressData) => api.post(`/${taskId}/progress`, taskProgressData),

  getProgressList: (taskId, filters) => {
    const params = buildQueryParams(filters);
    return api.get(`/${taskId}/progress?${params.toString()}`);
  },

  getTaskProgressById: (taskId, progressId) => api.get(`/${taskId}/progress/${progressId}`),

  updateTaskProgress: (taskId, progressId, taskProgressData) => api.patch(`/${taskId}/progress/${progressId}`, taskProgressData),

  deleteTaskProgress: (taskId, progressId) => api.delete(`/${taskId}/progress/${progressId}`),

  uploadTaskProgressAttachment: (taskId, progressId, formData) =>
    api.post(`/${taskId}/progress/${progressId}/attachments`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  getTaskProgressAttachments: (taskId, progressId) => api.get(`/${taskId}/progress/${progressId}/attachments`),

  getTaskProgressAttachmentById: (taskId, progressId, attachmentId) =>
    api.get(`/${taskId}/progress/${progressId}/attachments/${attachmentId}`),

  deleteTaskProgressAttachment: (taskId, progressId, attachmentId) =>
    api.delete(`/${taskId}/progress/${progressId}/attachments/${attachmentId}`),
};
